const init = () => {
	const searchForm = document.querySelector(".form--search");
    const queryInput = searchForm.querySelector(".form__input__query");

    searchForm.addEventListener("focus", (e) => {
        if (e.target.classList.contains("form__input__query")) {
            searchForm.classList.add("searching");
        }
    }, true);

    searchForm.addEventListener("focus", (e) => {
        searchForm.classList.add("searching");
    });

    document.addEventListener("keyup", (e) => {
        if (e.key === "Tab" && !searchForm.contains(e.target)) {
            searchForm.classList.remove("searching");
        }
    })

    document.addEventListener("click", (e) => {
        if (!searchForm.contains(e.target)) {
            searchForm.classList.remove("searching");
        }
        return false;
    });

    searchForm.addEventListener("submit", (e) => {
        if (queryInput.value === "" && !e.target.classList.contains("filter__radio")) {
            alert("Please enter a search query before submitting the form");
            e.preventDefault();
        }
    });
}

export const searchbar = {
    init: init
}